export default {"src":"/_next/static/media/disc-wheels.8121e0b3.svg","height":353,"width":475,"blurWidth":0,"blurHeight":0};